import { ChangeDetectionStrategy, Component, effect, signal } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { HttpService } from 'src/app/services/http.service';
import { ControlPoint } from '../../bo/controlPoint';
import { ProprieteAffichee } from '../../bo/proprieteAffichee';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { UtilisateurService } from '../../services/utilisateur.service';
import { SiteControlPointsModaleComponent } from '../site-control-points-modale/site-control-points-modale.component';

@Component({
  selector: 'app-site-control-points',
  templateUrl: './site-control-points.component.html',
  styleUrls: ['./site-control-points.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SiteControlPointsComponent {
  modaleModif: BsModalRef;
  tabControlPoints = signal<ControlPoint[]>([]);
  readonly proprietesAffichees: ProprieteAffichee[] = [];
  erreurRecuperation = signal(false);

  constructor(private readonly modalService: BsModalService, private readonly http: HttpService, private readonly fonctionsService: FonctionsService,
    private readonly utilService: UtilisateurService) {
    this.proprietesAffichees = new ControlPoint().getProprietesAffichees();
    effect(() => { this.utilService.currentSite(); this.refreshData(); });
  }


  ouvrirModale(ctrlPoint: ControlPoint) {
    let initialState;
    if (undefined !== ctrlPoint && null !== ctrlPoint) {
      initialState = {
        controlPoint: ctrlPoint,
        listControlPoint: this.tabControlPoints(),
        estModif: true,
        site: this.utilService.currentSite()
      }
    }
    else {
      initialState = {
        controlPoint: null,
        listControlPoint: this.tabControlPoints(),
        estModif: false,
        site: this.utilService.currentSite()
      }
    }
    this.modaleModif = this.modalService.show(SiteControlPointsModaleComponent, { backdrop: true, ignoreBackdropClick: true, keyboard: false, class: 'modal-lg', initialState });
    this.modaleModif.content.modaleFermee.subscribe(success => {
      this.fonctionsService.launch_toast(success);
      if (success) {
        this.refreshData();
      }
    });
  }

  private refreshData() {
    this.erreurRecuperation.set(false);
    this.fonctionsService.loading_screen(true);

    this.http.get<ControlPoint[]>('Sites/' + this.utilService.currentSite().siteId + '/ControlPoints', { transformCoord: true }).subscribe(resultat => {
      this.tabControlPoints.set(resultat);
      this.fonctionsService.loading_screen(false);
    }, () => {
      this.erreurRecuperation.set(true);
      this.fonctionsService.loading_screen(false);
    });
  }

}
